import React from 'react';
const PlaySVG = ({ color = 'white', className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="11"
      viewBox="0 0 9 11"
      fill="none"
    >
      <path
        d="M8.29404 4.17342L2.46458 0.26788C1.9777 -0.0582935 1.35519 -0.0890118 0.837936 0.188951C0.320706 0.466696 0 1.00576 0 1.59452V9.40713C0 9.99589 0.320695 10.5347 0.837936 10.8127C1.07246 10.9388 1.32991 11 1.58589 11C1.89279 11 2.19823 10.9108 2.46458 10.7325L8.29513 6.82696C8.73638 6.53129 9 6.03575 9 5.50177C9 4.96779 8.73639 4.47225 8.29388 4.17659L8.29404 4.17342ZM1.90168 8.81042V2.18832L6.84349 5.50019L1.90168 8.81205V8.81042Z"
        fill="currentColor"
      />
      <path
        d="M1.90168 8.81042V2.18832L6.84349 5.50019L1.90168 8.81205V8.81042Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PlaySVG;
